import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Book } from "@modules/books/types/book";

import { ListBooksQueryFilters } from "./types";

export async function getBooksService(filters?: ListBooksQueryFilters): Promise<Book[]> {
  try {
    const { data } = await api.get<ApiResponse<Book>>(`v1/book_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
        type: filters?.type,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching books:", error);
    throw error;
  }
}
